module.exports = __webpack_public_path__ + "static/media/kontakt.59df7b76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scss/icons/teaser/kontakt.svg
// module id = 915
// module chunks = 0